const TOGGLE_TO_IMAGE = 'app/toggle/TOGGLE_TO_IMAGE'
const TOGGLE_TO_VIDEO = 'app/toggle/TOGGLE_TO_VIDEO'

export { TOGGLE_TO_IMAGE, TOGGLE_TO_VIDEO }
